export const FEATURE_NAME = {
    // Management
    GEOFENCE_MANAGEMENT: 'GEOFENCE_MANAGEMENT',
    GEOFENCE_MANAGEMENT_ZONE_CREATE: 'GEOFENCE_MANAGEMENT_ZONE_CREATE',
    GEOFENCE_MANAGEMENT_ZONE_EDIT: 'GEOFENCE_MANAGEMENT_ZONE_EDIT',
    GEOFENCE_MANAGEMENT_POI_CREATE: 'GEOFENCE_MANAGEMENT_POI_CREATE',
    GEOFENCE_MANAGEMENT_POT_EDIT: 'GEOFENCE_MANAGEMENT_POI_EDIT',
    DEVICE_MANAGEMENT: 'DEVICE_MANAGEMENT',
    DRIVER_MANAGEMENT: 'DRIVER_MANAGEMENT',
    VEHICLE_MANAGEMENT: 'VEHICLE_MANAGEMENT',
    VEHICLE_GROUP_MANAGEMENT: 'VEHICLE_GROUP_MANAGEMENT',
    RULE_ENGINE_MANAGEMENT: 'RULE_ENGINE_MANAGEMENT',
    NOTIFICATION_MANAGEMENT: 'NOTIFICATION_MANAGEMENT',
    USER_MANAGEMENT: 'USER_MANAGEMENT',
    OVERALL_MANAGEMENT: 'OVERALL_MANAGEMENT',
    GPS_MANAGEMENT: 'GPS_MANAGEMENT',
    MDVR_MANAGEMENT: 'MDVR_MANAGEMENT',
    // Highway Surveillance Management
    HIGHWAY_SURVEILLANCE_MANAGEMENT: 'HIGHWAY_SURVEILLANCE_MANAGEMENT',
    // Maintenance Management
    OVERALL_MAINTENANCE_MANAGEMENT: 'OVERALL_MAINTENANCE_MANAGEMENT',
    OVERALL_MAINTENANCE_STATE: 'OVERALL_MAINTENANCE_STATE',
    MAINTENANCE_PROFILE_MANAGEMENT: 'MAINTENANCE_PROFILE_MANAGEMENT',
    MAINTENANCE_CONFIGURATION_MANAGEMENT: 'MAINTENANCE_CONFIGURATION_MANAGEMENT',
    // ROUTE_MANAGEMENT: 'ROUTE_MANAGEMENT',
    // VAM
    OVERALL_VEHICLE_ADVANCE_MAINTENANCE: 'OVERALL_VEHICLE_ADVANCE_MAINTENANCE',
    VEHICLE_REMINDER_MANAGEMENT: 'VEHICLE_REMINDER_MANAGEMENT',
    VEHICLE_ENTRY_MANAGEMENT: 'VEHICLE_ENTRY_MANAGEMENT',
    VEHICLE_ADVANCE_MAINTENANCE_CONFIGURATION_MANAGEMENT: 'VEHICLE_AVDANCE_MAINTENANCE_CONFIGURATION_MANAGEMENT',
    VEHICLE_ISSUES_MANAGEMENT: 'VEHICLE_ISSUES_MANAGEMENT',
    CREATE_VEHICLE_ISSUE: 'CREATE_VEHICLE_ISSUE',
    EDIT_VEHICLE_ISSUE: 'EDIT_VEHICLE_ISSUE',
    CREATE_SERVICE_ENTRY: 'CREATE_SERVICE_ENTRY',
    EDIT_SERVICE_ENTRY: 'EDIT_SERVICE_ENTRY',
    //Report
    REPORT_MANAGEMENT: 'REPORT_MANAGEMENT',
    ESCALATION_CALL_REPORT: 'ESCALATION_CALL_REPORT',
    VEHICLE_OVERALL_REPORT: 'VEHICLE_OVERALL_REPORT',
    FUEL_ANALYSIS_DASHBOARD: 'FUEL_ANALYSIS_DASHBOARD',
    DRIVER_REPORT: 'DRIVER_REPORT',
    CREATE_DRIVER_INCIDENT_REPORT: 'CREATE_DRIVER_INCIDENT_REPORT',
    DEVICE_REPORT: 'DEVICE_REPORT',
    // App Info
    VEHICLE_INFORMATION_PANEL: 'VEHICLE_INFORMATION_PANEL',
    VEHICLE_ROUTE_PLAYBACK: 'VEHICLE_ROUTE_PLAYBACK',
    VIDEO_ROUTE_PLAYBACK: 'VIDEO_ROUTE_PLAYBACK',
    VEHICLE_EVENT_TRACE: 'VEHICLE_EVENT_TRACE',
    USER_PROFILE: 'USER_PROFILE',
    USER_HIERARCHY_MAP: 'USER_HIERARCHY_MAP',
    LANDING_PAGE: 'LANDING_PAGE',
    CREATE_USER: 'CREATE_USER',
    UPDATE_USER: 'UPDATE_USER',
    CREATE_LIVE_TRACK_LINK: 'CREATE_LIVE_TRACK_LINK',
    CREATE_DRIVER: 'CREATE_DRIVER',
    UPDATE_DRIVER: 'UPDATE_DRIVER',
    CREATE_DEVICE: 'CREATE_DEVICE',
    UPDATE_DEVICE: 'UPDATE_DEVICE',
    CREATE_VEHICLE: 'CREATE_VEHICLE',
    UPDATE_VEHICLE: 'UPDATE_VEHICLE',
    CREATE_VEHICLE_GROUP: 'CREATE_VEHICLE_GROUP',
    UPDATE_VEHICLE_GROUP: 'UPDATE_VEHICLE_GROUP',
    CREATE_RULE: 'CREATE_RULE',
    UPDATE_RULE: 'UPDATE_RULE',
    CREATE_RULE_TEMPLATE: 'CREATE_RULE_TEMPLATE',
    UPDATE_RULE_TEMPLATE: 'UPDATE_RULE_TEMPLATE',
    CREATE_ROUTE: 'CREATE_ROUTE',
    LIVE_TRACK_LINK: 'LIVE_TRACK_LINK',
    // Third Party
    GREENER_WHEELS: 'GREENER_WHEELS',

}